import { useFieldHelper, TextField } from 'framework/ui/field';
import React from 'react';
import { PROCESS_STATE_CAPTIONS, ProcessState } from 'domain/gpo/cockpit/instance/processInstanceService';

// @ts-ignore
const ProcessStateField = ({ source, ...props }) => {
  const { getValue } = useFieldHelper<ProcessState>({ source });
  const state: ProcessState = getValue();
  return <TextField {...props} value={PROCESS_STATE_CAPTIONS[state]} />;
};

export default ProcessStateField;
